module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_5_3.5a53a022.png";